@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.sectionRow {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.titleMedium {
  @include typography-v2-title-md;
}

.bodySmall {
  @include typography-v2-body-sm;
}

.stepperWrapper {
  width: 100%;
  height: 76px;
  border: 1px solid var(--border-soft);
  @include border-radius-r2;
  padding: 18px;
}

.headerWrapper {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
